<template>
  <div
    v-if="initialized"
  >
    <oct-globalnav
      :user="user"
      @signout="onSignout"
    />

    <oct-account-form
      v-bind.sync="user"
      :process="status"
      @submit="submit"
    />

    <oct-globalfooter
      :user="user"
      @signout="onSignout"
      @quit="onQuit"
    />

    <oct-snackbar
      ref="$_octSnackbar"
    />

    <oct-svg />
  </div>
</template>

<script>
import OctAuth from '@/components/auth/OctAuth.js'
import OctApiAdaptor from '@/components/api-adaptor/OctApiAdaptor.js'
import OctAccountForm from '@/components/account-form/OctAccountForm.vue'
import OctPrototypeView from '@/views/OctPrototypeView.js'
import OctSvg from '@/components/svg/OctSvg.vue'
import '@/assets/app.scss'

export default {
  mixins: [OctAuth, OctPrototypeView],
  name: 'OctAccount',
  data () {
    return {
      /** Process status [new | initialized | processing | created ] */
      status: 'new'
    }
  },
  components: {
    OctAccountForm,
    OctSvg
  },
  methods: {
    /** Initialization */
    async initialize () {
      this.status = this.user.id ? 'initialized' : 'new'
      this.initialized = true
    },
    /** Form submit handler */
    async submit () {
      try {
        // Start processing
        this.status = 'processing'

        // Update the user
        await OctApiAdaptor.updateUser(this.user, this.token)

        // Notify complete message
        this.user.id && this.notify('保存しました')
      } catch (thrown) {
        alert('システムエラーが発生しました')
        console.log(thrown)
      } finally {
        // Undo process status and validation status
        this.status = this.user.id ? 'initialized' : 'created'
      }
    },
  }
}
</script>